import React from "react";

const DropdownType = (props) => {
  let className = "form-group pt-6 pl-3";
  if (props.showInDocUpload) {
    className = "form-group pt-3";
  }
  if (props.viewOnly) {
    className += " view-only row";
  }
  return (
    <div className={className}>
      <label
        className={[
          props.viewOnly ? "col-md-4 col-sm-6" : "bold",
          props.field.fieldLabel.length > 12 && props.viewOnly
            ? "hide-text"
            : "",
        ].join(" ")}
        htmlFor={props.field.fieldId}
      >
        {props.field.fieldLabel}
        {props.field.fieldRequired && !props.viewOnly && "*"}
      </label>
      <select
        className={[
          "form-control form-control-sm",
          props.viewOnly ? "col-md-8 col-sm-6 select-style pb-3" : "",
        ].join(" ")}
        onChange={props.dropdownValueChangeHandler}
        value={props.field.fieldValue}
        name={props.field.fieldLabel}
        id={props.field.fieldId}
        disabled={
          props.tabName === "overview" || props.viewOnly === true ? true : false
        }
      >
        {props.tabName || props.sectionTitle !== "Basic Details" ? (
          <option value="" disabled selected>
            {props.viewOnly ? "-" : "Please select.."}
          </option>
        ) : null}
        {props.field.options.map((option) => {
          return (
            <option key={option.optionId} value={option.optionValue}>
              {option.optionValue}
            </option>
          );
        })}
      </select>
    </div>
  );
};

export default DropdownType;
